<template>
	<div class="container-fluid no-select" ref="paymentFormContainer" v-cloak>
		<div class="row">

			<div class="col-12 col-form-container">

				<!-- step menu -->
				<div class="row row-steps">
					<div class="col-sm-6 col-step col-step-1" :class="classStep(1)" @click="selectStep(1)">
						<p>{{stepText1}}</p>
					</div>

					<div class="col-sm-6 col-step col-step-2" :class="classStep(2)" @click="selectStep(2)">
						<p>{{stepText2}}</p>
					</div>
				</div>
				<!-- step menu -->

				<!-- step 1: payment options -->
				<div class="row row-payment-options" v-show="showStep1Controls">
					<!-- row 1 -->
					<div class="col-md-1"></div>
					<div class="col-md-5 col-pay-option">
						<img class="pay-option-img" :class="classPayOptionStripeImg()" src="/img/credits/stripe-logo.png" @click="selectPayOptionStripe()" />
					</div>
					<div class="col-md-5 col-pay-option">
						<img class="pay-option-img" :class="classPayOptionPayPalImg()" src="/img/credits/paypal-logo.png" @click="selectPayOptionPayPal()" />
					</div>
					<div class="col-md-1"></div>
					<!-- row 1 -->

					<!-- row 2 -->
					<div class="col-md-1"></div>
					<div class="col-md-5 col-pay-option">
						<img class="pay-option-img" :class="classPayOptionCreditImg()" src="/img/credits/contentbase-credit-logo.png" @click="selectPayOptionCredit()" v-if="showCreditOption" />
					</div>
					<div class="col-md-5 col-pay-option">
					</div>
					<div class="col-md-1"></div>
					<!-- row 2 -->
				</div>
				<!-- step 1: payment options -->

				<!-- step 2: payment controls -->
				<div class="row row-stripe-controls" v-show="showStep2Controls">
					<div class="col-12 p-0">
						<stripe-card-form
							:key="keyStripeCardForm"
							:mode="mode"
							:crd-nr-credits="crdNrCredits"
							:pck-id="pckId"
							:pck-name="pckName"
							:pck-nr-credits="pckNrCredits"
							:pck-disc-per-id="pckDiscPerId"
							:pck-disc-per-nr-credits="pckDiscPerNrCredits"
							:usr-nr-credits="usrNrCredits"
							v-on:payment-started="paymentStarted($event)"
							v-on:payment-stopped="paymentStopped($event)"
							v-on:payment-completed="paymentCompleted($event)"
							v-if="payOptionStripeSelected"
						/>

						<pay-pal-form
							:key="keyPayPalForm"
							:mode="mode"
							:crd-nr-credits="crdNrCredits"
							:pck-id="pckId"
							:pck-name="pckName"
							:pck-nr-credits="pckNrCredits"
							:pck-disc-per-id="pckDiscPerId"
							:pck-disc-per-nr-credits="pckDiscPerNrCredits"
							:usr-nr-credits="usrNrCredits"
							v-on:payment-started="paymentStarted($event)"
							v-on:payment-stopped="paymentStopped($event)"
							v-on:payment-completed="paymentCompleted($event)"
							v-if="payOptionPayPalSelected"
						/>

						<content-base-credit-form
							:key="keyCreditForm"
							:mode="mode"
							:crd-nr-credits="crdNrCredits"
							:pck-id="pckId"
							:pck-name="pckName"
							:pck-nr-credits="pckNrCredits"
							:pck-disc-per-id="pckDiscPerId"
							:pck-disc-per-nr-credits="pckDiscPerNrCredits"
							:usr-nr-credits="usrNrCredits"
							v-on:payment-started="paymentStarted($event)"
							v-on:payment-stopped="paymentStopped($event)"
							v-on:payment-completed="paymentCompleted($event)"
							v-if="payOptionCreditSelected"
						/>

					</div>
				</div>
				<!-- step 2: payment controls -->

				<!-- step 1: nav arrows -->
				<div class="row row-nav-arrows" v-show="showNavArrowRowStep1">
					<div class="col-lg-6 col-nav-arrow col-nav-arrow-step-left">
						<!-- placeholder -->
					</div>

					<div class="col-lg-6 col-nav-arrow col-nav-arrow-step-right">
						<div class="div-nav-arrow div-nav-arrow-2" v-show="showNavArrowStep1Forward" @click="selectStep(2)">
							<span class="span-nav-cta">{{stepText2}}</span>
							<img class="img-nav-arrow" src="/img/gfx/red-arrow-right-100.png" />
						</div>
					</div>
				</div>
				<!-- step 1: nav arrows -->

				<!-- step 2: nav arrows -->
				<div class="row row-nav-arrows" v-show="showNavArrowRowStep2">
					<div class="col-lg-6 col-nav-arrow col-nav-arrow-step-left">
						<div class="div-nav-arrow div-nav-arrow-1" v-show="showNavArrowStep2Backward" @click="selectStep(1)">
							<img class="img-nav-arrow" src="/img/gfx/red-arrow-left-100.png" />
							<span class="span-nav-cta">{{stepText1}}</span>
						</div>
					</div>

					<div class="col-lg-6 col-nav-arrow col-nav-arrow-step-right">
						<!-- placeholder -->
					</div>
				</div>
				<!-- step 2: nav arrows -->

			 </div>
		</div>
	</div>
</template>




<script>
	import stripeCardForm from './StripeCardForm.vue';
	import payPalForm from './PayPalForm.vue';
	import contentBaseCreditForm from './ContentBaseCreditForm.vue';

	export default {
		mixins: [mixinAxios],
		components: {
			stripeCardForm,
			payPalForm,
			contentBaseCreditForm
		},
		data: () => ({
			enumPaymentOption : {},
			userHasAccountCredit : false,
			accessToTestCredits : false,
			discountPeriod : {},
			selectedStep : 1,
			paymentSuccess : false,
			keyStripeCardForm: 0,
			keyPayPalForm: 0,
			keyCreditForm: 0,
			payOption : 0,
			idPopupHideInterval : 0
		}),
		props: {
			// which mode: credit/package
			mode                : { type: String, default: null },

			// buying account credit mode
			crdNrCredits        : { type: Number, default: 0 },

			// buying package mode (with fiat)
			pckId               : { type: Number, default: 0 },
			pckName             : { type: String, default: '' },
			pckNrCredits        : { type: Number, default: 0 },
			pckDiscPerId        : { type: Number, default: null },
			pckDiscPerNrCredits : { type: Number, default: null },

			// other info
			usrNrCredits        : { type: Number, default: 0 },

			// style stuff
			width               : { type: String, default: '' },
			minWidth            : { type: String, default: '' },
			maxWidth            : { type: String, default: '' }
		},
		mounted() {
			this.setWidth();
			this.initData();
		},
		methods: {
			initData() {
				var reqCreditFormInfo = this.mixinAxios().get('/api/user/GetPaymentFormInfo').then((resCreditFormInfo) => {
					var data                  = resCreditFormInfo?.data;
					this.enumPaymentOption    = data?.enumPaymentOption;
					this.userHasAccountCredit = data?.userHasAccountCredit ?? false;
				});
			},
			resetDefaultView() {
				this.selectedStep   = 1;
				this.paymentSuccess = false;

				this.keyStripeCardForm++;
				this.keyPayPalForm++;
				this.keyCreditForm++;
			},
			setWidth() {
				var setWidth    = (this.width.notNullOrWhitespace());
				var setMinWidth = (this.minWidth.notNullOrWhitespace());
				var setMaxWidth = (this.maxWidth.notNullOrWhitespace());

				this.paymentFormContainer.style.width    = (setWidth)    ? common.parseWidthValue(this.width)    : '';
				this.paymentFormContainer.style.minWidth = (setMinWidth) ? common.parseWidthValue(this.minWidth) : '';
				this.paymentFormContainer.style.maxWidth = (setMaxWidth) ? common.parseWidthValue(this.maxWidth) : '';
			},
			selectStep(id) {
				var selectStep1   = (id == 1 && this.step2Enabled);
				var selectStep2   = (id == 2 && this.step2Enabled);
				this.selectedStep = (selectStep1 || selectStep2) ? id : this.selectedStep;

				// todo: don't scroll into view when clicking on disabled step
				// smooth scroll not working, but whatever...
				this.scrollIntoView({ behavior: 'smooth' });
			},
			scrollIntoView() {
				this.paymentFormContainer.scrollIntoView();
			},
			selectCreditPackage(id) {
				this.idSelectedCreditPackage = id;
			},
			selectPayOption(name) {
				this.payOption = this.enumPaymentOption?.byName?.[name]?.value ?? 0;
			},
			payOptionSelectedByName(name) {
				return (this.payOption == this.enumPaymentOption?.byName?.[name]?.value ?? 0);
			},
			selectPayOptionStripe() {
				this.selectPayOption('stripe');
			},
			selectPayOptionPayPal() {
				this.selectPayOption('payPal');
			},
			selectPayOptionCredit() {
				this.selectPayOption('credit');
			},
			paymentStarted(e) {
				this.$emit('payment-started', e);
			},
			paymentStopped(e) {
				this.$emit('payment-stopped', e);
			},
			paymentCompleted(e) {
				this.paymentSuccess = true;
				this.$emit('payment-completed', e);
			},
			classStep(id) {
				var step1Disabled = (id == 1) && (!this.step1Enabled);
				var step2Disabled = (id == 2) && (!this.step2Enabled);

				return {
					'selected' : (id == this.selectedStep),
					'disabled' : (step1Disabled || step2Disabled)
				};
			},
			classPayOptionStripeImg() {
				return {
					'selected' : (this.payOptionStripeSelected)
				};
			},
			classPayOptionPayPalImg() {
				return {
					'selected' : (this.payOptionPayPalSelected)
				};
			},
			classPayOptionCreditImg() {
				return {
					'selected' : (this.payOptionCreditSelected)
				};
			}
		},
		computed: {
			modeLower() {
				return this.mode?.toLowerCase();
			},
			creditMode() {
				return (this.modeLower == 'credit');
			},
			packageMode() {
				return (this.modeLower == 'package');
			},
			payOptionStripeSelected() {
				return (this.payOptionSelectedByName('stripe'));
			},
			payOptionPayPalSelected() {
				return (this.payOptionSelectedByName('payPal'));
			},
			payOptionCreditSelected() {
				return (this.payOptionSelectedByName('credit'));
			},
			payOptionSelected() {
				return (this.payOptionStripeSelected || this.payOptionPayPalSelected || this.payOptionCreditSelected);
			},
			showCreditOption() {
				return (this.packageMode && this.userHasAccountCredit);
				//return (this.packageMode);
			},
			stepText1() {
				return '1. Select Payment Option';
			},
			stepText2() {
				return (this.payOptionStripeSelected)
					? '2. Pay With Stripe'
					: (this.payOptionPayPalSelected)
					? '2. Pay With PayPal'
					: (this.payOptionCreditSelected)
					? '2. Pay With Credit'
					: '2. Pay';
			},
			showStep1Controls() {
				return (this.selectedStep == 1);
			},
			showStep2Controls() {
				return (this.selectedStep == 2);
			},
			step1Enabled() {
				return (!this.paymentSuccess);
			},
			step2Enabled() {
				return (this.payOptionSelected) && (!this.paymentSuccess);
			},
			showNavArrowStep1Forward() {
				return this.step2Enabled;
			},
			showNavArrowStep2Backward() {
				return false;
			},
			showNavArrowRowStep1() {
				return (this.showStep1Controls) && (this.showNavArrowStep1Forward);
			},
			showNavArrowRowStep2() {
				return (this.showStep2Controls) && (this.showNavArrowStep2Backward);
			},
			paymentFormContainer() {
				return this.$refs['paymentFormContainer'];
			},
			showClosingNotification() {
				return (this.existsInPopup) && (this.paymentSuccess);
			}
		}
	};
</script>




<style scoped>

	/* COMPONENT */

	.col-form-container {
		border: 1px solid #cccccc;
		border-radius: 10px;
		background: #ffffff;
		padding-bottom: 15px;
	}

	/* COMPONENT */



	/* TIMER */

	.col-timer {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.col-timer span {
		font-weight: bold;
		font-size: 20px;
		color: red;
		margin-bottom: 10px;
	}

	/* TIMER */



	/* STEP BUTTONS */

	.row-steps {
		border-bottom: 1px solid #cccccc;
	}

	.row-steps p {
		margin: 10px 0px;
		font-weight: bold;
	}

	.col-step {
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		background: #ffffff;
	}

	.col-step.selected {
		background: rgb(224, 231, 255);
	}

	.col-step.disabled {
		color: #aaaaaa;
		cursor: default;
	}

	.col-step-1 {
		border-top-left-radius: 10px;
	}

	.col-step-2 {
		border-top-right-radius: 10px;
		border-left: 1px solid #cccccc;
	}

	@media screen and (max-width: 576px) {
		.col-step-1 {
			border-top-right-radius: 10px;
		}

		.col-step-2 {
			border-top-right-radius: 0px;
			border-left: 0px solid #cccccc;
			border-top: 1px solid #cccccc;
		}
	}

	/* STEP BUTTONS */




	/* NAV ARROWS */

	.row-nav-arrows {
		margin-top: 15px;
	}

	.col-nav-arrow {
		/*
		padding-top:5px;
		padding-bottom:5px;
		*/
	}

	.img-nav-arrow {
		width: 75px;
	}

	.col-nav-arrow {
		display: flex;
		align-items: center;
	}

	.col-nav-arrow-step-left {
		justify-content: flex-start;
	}

	.col-nav-arrow-step-right {
		justify-content: flex-end;
	}

	.span-nav-cta {
		font-weight: bold;
	}

	.col-nav-arrow-step-left .span-nav-cta {
		margin-left: 15px;
	}

	.col-nav-arrow-step-right .span-nav-cta {
		margin-right: 15px;
	}

	.div-nav-arrow {
		border: 1px solid #cccccc;
		border-radius: 10px;
		padding: 5px 15px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.div-nav-arrow-1 {
	}

	.div-nav-arrow-2 {
		animation: nav-arrow-blink 4s ease-in-out infinite;
	}

	@keyframes nav-arrow-blink {
		0% {
			background: rgb(255,255,255);
			border: 1px solid #cccccc;
		}

		40% {
			background: rgb(224,231,255);
			border: 1px solid #000000;
		}

		80% {
			background: rgb(255,255,255);
			border: 1px solid #cccccc;
		}

		100% {
			background: rgb(255,255,255);
			border: 1px solid #cccccc;
		}
	}

	@media screen and (max-width: 350px) {
		.img-nav-arrow {
			width: 50px;
		}
	}

	/* NAV ARROWS */




	/* CREDIT PACKAGES */

	.row-credit-packages {
		padding: 0px 15px 0px 0px;
	}

	.col-credit-package {
		padding: 15px 0px 0px 15px;
	}

	.div-credit-package {
		border: 1px solid #cccccc;
		border-radius: 10px;
		background: #ffffff;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.div-credit-package.selected {
		border: 1px solid rgb(67, 56, 202);
		background: rgb(224, 231, 255);
	}

	.div-credit-package p {
		margin: 10px 0px;
		font-weight: bold;
	}

	.div-credit-package-credits {
		background: rgb(67, 56, 202);
		color: #ffffff;
		width: 100%;
		text-align: center;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
	}

	.div-credit-package-price {
		font-family: 'Saira Condensed', sans-serif;
		font-size: 40px;
		font-weight: normal;
		letter-spacing: 0.03em;
		line-height: 40px;
	}

	.div-credit-package-price-discount {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.suppress-price p {
		color: lightgray;
		font-size: 30px;
		margin-bottom: 0px;
	}

	.suppress-discount p {
		color: lightgray;
		font-size: 0.95rem;
		margin-top: 0px;
	}

	.div-credit-package-discount {
		color: rgb(67,56,202);
	}

	/* CREDIT PACKAGES */




	/* PAYMENT OPTIONS */

	.col-pay-option {
		margin-top: 15px;
		text-align: center;
	}

	.pay-option-img {
		border: 3px solid #CCCCCC;
		border-radius: 10px;
		cursor: pointer;
		width: 100%;
		max-width: 266px; /* current images' intrinsic width */
	}

	.pay-option-img.selected {
		border: 3px solid rgb(67,56,202);
	}

	/* PAYMENT OPTIONS */




	/* RIBBON */

	.ribbon-wrap {
		position: absolute;
		right: -33px;
		top: 18px;
		width: 130px;
		-ms-transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		border-left: 25px solid transparent;
		border-right: 25px solid transparent;
		border-bottom: 25px solid #ff4444;
		box-shadow: 0px 6px 5px -5px rgba(0, 0, 0, 0.5);
		z-index: 999;
	}

	.ribbon-wrap.a-right {
		-ms-transform: rotate(45deg);
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.ribbon-wrap .trap-ribbon {
		position: absolute;
		left: 13px;
		top: 3px;
		font-size: 16px;
		font-weight: bold;
		line-height: 19px;
		color: white;
		width: auto;
		text-align: center;
		word-spacing: -1px;
	}

	/* RIBBON */




	/* COMMON */

	[v-cloak] {
		display: none;
	}

	h5 {
		color: #8c8c8c;
	}

	.strike-through {
		text-decoration: line-through;
	}

	.p-big-bold {
		font-size: 17px;
		font-weight: bold;
	}

	/* COMMON */

</style>